import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslationModuleEnum } from "../../../utils/translation-modules.enum";

@Component({
  selector: "app-validation",
  templateUrl: "./validation.component.html",
  styleUrls: ["./validation.component.scss"],
})
export class ValidationComponent implements OnInit {
  ngOnInit(): void {
    this.control.valueChanges.subscribe(re => {
      // console.log(this.keysOfErrors, 'sdsd');
    });
  }
  translationModulesEnum = TranslationModuleEnum;
  @Input() control: FormControl | undefined;
  @Input() length: number;
  @Input() minLength: number = 0;
  @Input() maxLength: number = 0;
  @Input() valideMax : boolean = true
  @Input() showRangeError : boolean = true
  @Input() minValue: number = 0;
  @Input() maxValue: number = 0;
  @Input() minValueNew: number = 0;
  @Input() maxValueNew: number = 0;
  get keysOfErrors() {
    if (this.control?.errors) return Object.keys(this.control?.errors as []);
    return [];
  }
}
